import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SubdomainRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  canActivate(): boolean {
    const hostname = this.document.location.hostname;

    if (hostname.startsWith('old-admin.') || hostname.startsWith('admin.')) {
      this.router.navigate(['/admin']);
      return false;
    }

    if (hostname.startsWith('host.')) {
      this.router.navigate(['/host']);
      return false;
    }

    // 사용자 사이트(/tabs)는 폐지됨. admin/host 서브도메인이 아닌 bare 도메인(로컬/test)에선
    // 로그인 상태면 호스트 화면으로, 아니면 로그인 화면으로 보낸다.
    // 로그인 후 returnUrl 없이 '/'로 돌아와도 이미 인증 상태라 /host 로 가므로 로그인 루프가 생기지 않는다.
    this.router.navigate([this.authService.isAuthenticated() ? '/host' : '/tabs/login']);
    return false;
  }
}
